/**
 * Helpers da impersonation (Master se passa por outro usuário do tenant).
 * Persistência em localStorage; interceptors do axios injetam o header
 * X-Impersonate-UsuarioId quando ativa.
 *
 * Shape: { usuarioId: number, nome: string, tipo: 'jurado' | 'produtor' }
 */

const KEY = 'konq.impersonar';

export function getImpersonado() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const obj = JSON.parse(raw);
    if (obj && typeof obj.usuarioId === 'number' && obj.usuarioId > 0) return obj;
    return null;
  } catch {
    return null;
  }
}

export function setImpersonado({ usuarioId, nome, tipo }) {
  if (typeof usuarioId !== 'number' || usuarioId <= 0) return;
  localStorage.setItem(KEY, JSON.stringify({ usuarioId, nome: nome ?? '', tipo: tipo ?? '' }));
}

export function clearImpersonado() {
  localStorage.removeItem(KEY);
}

/** Retorna só o usuarioId (ou null) — usado pelos interceptors. */
export function getImpersonateUsuarioId() {
  return getImpersonado()?.usuarioId ?? null;
}
